
export const updateCategories = (data) => {
    return (dispatch, getState) => {
        if (typeof(data) == 'object' || Array.isArray(data)) {
            dispatch({ type: 'DATA', category: 
            { ...data } })
        } else {
            dispatch({ type: "ERROR", category: [] });
        }
    }
}